<template>
  <div ref="scrollElement" class="page-news wh-full overflow-auto">
    <div class="page-news-banner flex-col justify-center items-center">
      <Resource
        class="page-news-banner__img"
        :src="pageBackground"
        :transform-resource="transformImage"
      ></Resource>
      <h1 class="mb-[16px]">
        <span :class="isChinese() ? 'text-gradient' : 'text-white'">
          {{ pageTitle }}
        </span>
      </h1>
      <p :class="['font-[500]', isChinese() ? 'text-[#0d93fa]' : 'text-white']">
        {{ pageSubTitle }}
      </p>
    </div>
    <article class="page-news-content mx-auto pb-[100px]">
      <section class="mod-highlight">
        <h3>{{ $t('gong-neng-liang-dian') }}</h3>
        <Highlight mode="grid" />
      </section>
      <section class="mod-change-video">
        <UpdateVideo />
      </section>
    </article>
  </div>
</template>

<script lang="ts" setup>
import { get } from 'lodash-es'
import UpdateVideo from './UpdateVideo.vue'
import { getPromotionCenterPageCard } from '~/api/module/publicize'
import { PAGE_CARD_TYPE } from '~/api/interface/publicize'
import Highlight from '~/components/content/highlight/index.vue'

const { data: pageData } = useAsyncData(async () => {
  const res = await getPromotionCenterPageCard({
    type: PAGE_CARD_TYPE.NEWS,
  })
  return res.data
})

const pageTitle = computed(() =>
  get(pageData.value, '[0].title', '产品最新动态')
)

const pageSubTitle = computed(() =>
  get(pageData.value, '[0].sub_title', '带你了解有言产品成长历程')
)

const pageBackground = computed(() => get(pageData.value, '[0].cover_url'))
</script>
<style lang="scss" scoped>
h3 {
  font-weight: 600;
  font-size: 18px;
  color: var(--text-1);
  margin-bottom: 16px;
  margin-top: 48px;
}

.page-news {
  &-banner {
    position: relative;
    height: 266px;
    gap: 16px;
    &__img {
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    h1,
    p {
      position: relative;
      z-index: 1;
    }
    h1 {
      font-size: 48px;
      margin: 0;
      .text-gradient {
        background-image: linear-gradient(to right, #ef17fd, #05d4ff);
        -webkit-background-clip: text;
        color: transparent;
      }
    }
    p {
      margin: 0;
      font-size: 20px;
    }
  }
  &-content {
    width: 1200px;
  }
}
</style>
